import React from "react";
import * as THREE from "three";

// import lucien from "../assets/img/castle.png";

export const Smoke = ({ b = 3, clouds }) => {
  var camera,
    scene,
    renderer,
    clock,
    textGeo,
    textTexture,
    textMaterial,
    text,
    light,
    smokeTexture,
    smokeMaterial,
    smokeGeo,
    smokeParticles,
    p,
    delta,
    cubeSineDriver,
    lucienMesh,
    lucienGeo;

  var geometry, material, mesh;
  const [mouse, setMouse] = React.useState(0, 0);

  const castleStartPosMultiplier = -0.6;
  const castleWidthMult = 1;
  const casWidth = 900;

  const randomize = false;

  const init = (b) => {
    clock = new THREE.Clock();

    renderer = new THREE.WebGLRenderer({ alpha: true });
    renderer.setSize(window.innerWidth, window.innerHeight);

    scene = new THREE.Scene();

    camera = new THREE.PerspectiveCamera(
      75,
      window.innerWidth / window.innerHeight,
      1,
      10000
    );
    camera.position.z = 900;
    scene.add(camera);

    geometry = new THREE.CubeGeometry(200, 200, 200);
    material = new THREE.MeshLambertMaterial({
      color: 0xaa6666,
      wireframe: false,
    });
    mesh = new THREE.Mesh(geometry, material);
    //scene.add( mesh );
    cubeSineDriver = 0;

    THREE.ImageUtils.crossOrigin = ""; //Need this to pull in crossdomain images from AWS

    // lucienGeo = new THREE.PlaneGeometry(
    //   casWidth * castleWidthMult,
    //   casWidth * castleWidthMult
    // );
    // var loader = new THREE.TextureLoader();
    // let lucienMaterial = new THREE.MeshLambertMaterial({
    //   map: loader.load(lucien),
    //   transparent: true,
    // });
    // lucienMesh = new THREE.Mesh(lucienGeo, lucienMaterial);
    // lucienMesh.position.set(
    //   0,
    //   window.innerHeight * castleStartPosMultiplier,
    //   200
    // );

    // scene.add(lucienMesh);

    light = new THREE.DirectionalLight(0xffffff, b);
    light.position.set(-1, 0, 1);
    scene.add(light);

    smokeTexture = THREE.ImageUtils.loadTexture(
      "https://s3-us-west-2.amazonaws.com/s.cdpn.io/95637/Smoke-Element.png"
    );
    smokeMaterial = new THREE.MeshLambertMaterial({
      color: 0xffffff,
      map: smokeTexture,
      transparent: true,
      opacity: 0.6,
    });
    smokeGeo = new THREE.PlaneGeometry(600, 600);
    smokeParticles = [];

    let arrayOfRandoms = [];

    if (randomize) {
      for (p = 0; p < 10; p++) {
        var particle = new THREE.Mesh(smokeGeo, smokeMaterial);
        let ran1 = Math.random() * 500 - 250;
        let ran2 = Math.random() * 500 - 250;
        let ran3 = Math.random() * 1000 - 100;
        let ran4 = Math.random() * 360;
        particle.position.set(ran1, ran2, ran3);
        particle.rotation.z = ran4;

        scene.add(particle);
        smokeParticles.push(particle);
        let rans = [ran1, ran2, ran3, ran4];
        arrayOfRandoms.push(rans);
      }
    } else {
      let ranGoodOne = Math.floor(Math.random() * goodOnes.length);
      console.log(ranGoodOne);
      for (p = 0; p < clouds; p++) {
        var particle = new THREE.Mesh(smokeGeo, smokeMaterial);
        let rans = goodOnes[6];
        particle.position.set(rans[p][0], rans[p][1], rans[p][2]);
        particle.rotation.z = rans[p][3];
        scene.add(particle);
        smokeParticles.push(particle);
      }
    }

    console.log(JSON.stringify(arrayOfRandoms));

    document.getElementById("smoke").appendChild(renderer.domElement);
  };

  function animate() {
    // note: three.js includes requestAnimationFrame shim

    delta = clock.getDelta();
    requestAnimationFrame(animate);
    evolveSmoke();

    render();
  }

  function evolveSmoke() {
    var sp = smokeParticles.length;
    while (sp--) {
      smokeParticles[sp].rotation.z += delta * 0.2;
    }
  }

  function render() {
    mesh.rotation.x += 0.005;
    mesh.rotation.y += 0.01;
    cubeSineDriver += 0.01;
    mesh.position.z = 100 + Math.sin(cubeSineDriver) * 500;

    // lucienMesh.position.y =
    //   window.innerHeight * castleStartPosMultiplier + window.scrollY / 6;

    renderer.render(scene, camera);
  }

  React.useEffect(() => {
    init(b);
    animate();
    window.addEventListener("resize", () => {
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();

      renderer.setSize(window.innerWidth, window.innerHeight);
    });
  }, []);

  React.useEffect(() => {
    if (light !== undefined) light.intensity = b;
  }, [b]);

  return <div id="smoke" style={{ zIndex: -1 }}></div>;
};

const goodOnes = [
  [
    [
      53.10332542538731, 45.509682374227395, 24.47703798702281,
      71.34275696293032,
    ],
    [
      59.255039218390266, -244.1566498884502, 544.4218421016874,
      219.39144630484248,
    ],
    [
      -91.1808694252596, 186.11985766370532, 340.07253586363083,
      17.5506436896329,
    ],
    [
      -231.27106603208003, 175.6835811079801, 188.8247489861959,
      24.97087269743755,
    ],
    [
      -153.31632573563456, -182.7654340453131, 480.4259215853349,
      133.13146194214124,
    ],
    [
      192.0107879331444, 127.67343872205527, 87.93238096454525,
      3.567035536108163,
    ],
    [
      247.19062958393255, -236.76848894860302, 376.98229659452693,
      280.83838743509045,
    ],
    [
      91.16398668904958, 107.31554473843966, 409.0016844096172,
      138.14888497069882,
    ],
    [
      -114.24426452707749, -151.74499349158464, 133.167207100216,
      100.50272827646519,
    ],
    [
      -62.12266915322985, 43.448548414698905, 648.1050833816734,
      20.885617185928975,
    ],
  ],
  [
    [
      -158.69587431074572, -27.764485671208604, 226.97272895145943,
      300.4171071723687,
    ],
    [
      101.27377843442122, -134.12649315744153, 478.82393740220436,
      281.9247323118042,
    ],
    [
      -205.7388097553856, -176.17378255701655, 226.37159568711138,
      270.4899091806876,
    ],
    [
      -215.78827527646084, 16.022217775404556, 212.17835394367734,
      130.84234449093836,
    ],
    [
      165.4892851129327, -61.873114717200025, 241.38260947233044,
      302.09663840165535,
    ],
    [
      -30.701474324288824, -182.34451613969247, 108.70952659161591,
      88.19061020851424,
    ],
    [
      -162.06844501348849, -198.07239216547845, 210.50508885213344,
      342.75144980925916,
    ],
    [
      -217.6743941033148, -204.17879361657765, 734.6698071508423,
      154.05208189033215,
    ],
    [
      155.3279135867033, -54.715310672639674, 712.6130683745591,
      237.67251943751384,
    ],
    [
      -193.1089779534554, 83.34869815724034, 74.44820475889622,
      238.0791457287174,
    ],
  ],
  [
    [
      -143.30042821320765, 140.14684467773043, 656.8458545153946,
      332.2832500312419,
    ],
    [
      164.55695545575333, -194.16108575989665, 0.6686468957405083,
      334.77208268393224,
    ],
    [
      69.92069372567511, -81.1681033592223, 33.08249026212704,
      251.86392313458106,
    ],
    [
      144.21336339742885, -59.64858296705211, 461.9826500726846,
      132.55720243189882,
    ],
    [
      54.87787382791021, -208.70344462784763, 375.95333349538936,
      49.06203625927749,
    ],
    [
      172.7609579306004, 72.60272648068388, 464.08666691269843,
      253.50602406100234,
    ],
    [
      143.14884099472647, -184.45996162699953, 401.6370307121494,
      261.80171479048863,
    ],
    [
      82.1949663170912, 39.41234670251117, -77.42173262121824,
      155.91024385491497,
    ],
    [
      -63.495211742359515, 198.0729147012761, 232.3912541447167,
      306.9814573930634,
    ],
    [
      45.67515082787577, -12.067591006404541, -53.039898207678206,
      150.94417129734262,
    ],
  ],
  [
    [
      172.6986951516074, -52.84512763841752, 359.8513586133961,
      148.45827221351635,
    ],
    [
      25.1017484918292, -71.78175857255553, -31.774523774753447,
      342.054250335824,
    ],
    [
      -168.9950327620755, 142.53385860312306, 342.0070129643166,
      269.65684993210886,
    ],
    [
      116.79401356741704, -208.1356707354697, 645.0609282229154,
      161.71213452919355,
    ],
    [
      -107.70567847031799, -137.3930077224027, 580.8996047803184,
      329.4990559462066,
    ],
    [
      20.421985339988737, -94.73476265681802, 8.988508081707678,
      36.35883672792693,
    ],
    [
      -116.36363639317281, -209.12369343929248, 624.8870027621657,
      42.57518434923038,
    ],
    [
      -229.83932151031172, -242.74362294778194, -2.952901441414383,
      156.22543380136048,
    ],
    [
      -55.03122744546653, 190.3284216866371, 96.472250354478,
      153.42316000484183,
    ],
    [
      31.91511154430816, 157.5192975365194, 303.84354050020454,
      149.23183822418665,
    ],
  ],
  [
    [
      -183.89320776513472, -9.82908842519447, 139.6663904473406,
      113.63163863291204,
    ],
    [
      67.08438048457612, 240.67661218517577, -63.23665229934807,
      44.58071405062179,
    ],
    [
      12.245865453377576, -130.38185719970073, 130.93563336673674,
      99.39224848493397,
    ],
    [
      152.13802969665267, -60.189875323735436, 427.73942603832256,
      297.03929359948154,
    ],
    [
      128.3161707022187, -40.52788939879625, 457.2520662772333,
      353.2174066559726,
    ],
    [
      -165.28239265416488, -165.95012854243186, 188.25024218947817,
      20.889362336456195,
    ],
    [
      229.21548754874556, -159.70351439158924, 30.18762795303806,
      286.0657782133952,
    ],
    [
      120.4461001877981, 108.63900847321872, 391.1594947483422,
      272.6999350275804,
    ],
    [
      157.15315217144143, -9.510966058052361, 733.8537803504478,
      303.5098231876378,
    ],
    [
      122.7864098560658, -56.3445844253836, 582.5794518353607,
      95.92813415540765,
    ],
  ],
  [
    [
      -70.52251355674034, 123.54085032479645, 272.24325348484723,
      43.77489552880435,
    ],
    [
      -7.09454774377582, -17.809578255237312, -75.80551516481817,
      273.22005404946185,
    ],
    [
      -17.951767084105057, -74.24935924591358, 230.23017446449774,
      343.3953655392603,
    ],
    [
      -210.4972977210241, 37.56176567644411, 695.7188248228717,
      33.36274521292914,
    ],
    [
      -19.22213233885205, 79.55327606493046, 225.5323831795689,
      72.75707741873477,
    ],
    [
      -56.56637331688273, 29.663656328422178, 435.49663963997784,
      1.3568555817082917,
    ],
    [
      -107.68348677662487, -108.41438754222378, 106.38730584608655,
      337.2888812234972,
    ],
    [
      -213.57319786670035, 167.53563039026295, 525.5134824904687,
      63.382759701616614,
    ],
    [
      -37.02576294408689, 13.333058032373629, 35.08055047296975,
      197.51521784486658,
    ],
    [
      -174.03252674404823, -82.55934357568128, 279.13490194700404,
      268.72513727764743,
    ],
  ],
  [
    [
      49.801833421563856, 152.24558783171284, 51.12763002415309,
      252.95687253983425,
    ],
    [
      -140.60209051047224, -237.07520487602474, 259.32617140093083,
      352.0312923370992,
    ],
    [
      171.98306456170508, -241.33297568918331, 806.1410704282005,
      3.048658048854831,
    ],
    [
      -194.71898737860062, 246.65386226159802, -90.50070326056372,
      170.42445029726534,
    ],
    [
      244.86219432990742, 195.3271654546661, 172.8774978390893,
      258.7135256687953,
    ],
    [
      -166.2561729976444, 245.02403668093785, 784.5886243066121,
      333.7602258628717,
    ],
    [
      -132.48603691025272, -211.29811360942418, 625.6443007967539,
      115.15203884814281,
    ],
    [
      -83.37185964378168, -22.017592118981696, 567.4271278148276,
      183.07421323989118,
    ],
    [
      -152.45702850789556, 213.20644933993225, 56.829232811744646,
      186.8570247538855,
    ],
    [
      113.00171923631052, 239.67553455491662, 567.655219103485,
      83.9017905963046,
    ],
  ],
];
